module.exports = __webpack_public_path__ + "img/wenhao.bfbba415.png";